import { categoryList } from "@/mocks/melon";

export default function Category() {
  return (
    <section id="category" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="mb-2 text-xs font-bold tracking-widest text-primary-500">CHANNELS</p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">栏目分类</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">按领域分好类，想看哪个圈子的热点直接进，省得大海捞针。</p>
          </div>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categoryList.map((c) => (
            <a
              key={c.name}
              href="#top"
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:border-secondary-300 hover:bg-secondary-50/70"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={c.icon} aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-base font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-0.5 truncate text-xs text-foreground-500">{c.desc}</p>
                <p className="mt-1 text-xs text-secondary-600">{c.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}